import { render, staticRenderFns } from "./moveAddApply.vue?vue&type=template&id=5610a0ab&scoped=true&"
import script from "./moveAddApply.vue?vue&type=script&lang=js&"
export * from "./moveAddApply.vue?vue&type=script&lang=js&"
import style0 from "./moveAddApply.vue?vue&type=style&index=0&id=5610a0ab&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5610a0ab",
  null
  
)

export default component.exports